import { Autocomplete, FormControlLabel, Grid, Radio, RadioGroup, TextField } from "@mui/material"
import { AppNode } from "@features/builder/graph/types"
import { MAX_SELECTED_NODES } from "./helpers"
import { EdgeDirection, NodeSelectRowProps } from "@features/builder/CreateEdges/types"

const getNodeLabel = (node: AppNode) => node.data.label ?? node.id

const NodeSelectRow = ({
  direction,
  onDirectionChange,
  options,
  value,
  onChange,
  label,
  error,
}: NodeSelectRowProps) => (
  <>
    <Grid item xs={4}>
      <RadioGroup
        value={direction}
        onChange={(e) => onDirectionChange(e.target.value as EdgeDirection)}
      >
        <FormControlLabel value="Children" control={<Radio />} label="Children" />
        <FormControlLabel value="Parents" control={<Radio />} label="Parents" />
      </RadioGroup>
    </Grid>
    <Grid item xs={8}>
      <Autocomplete<AppNode, true>
        multiple
        options={options}
        value={value}
        onChange={(_, newValue) => onChange(newValue.slice(0, MAX_SELECTED_NODES))}
        getOptionLabel={getNodeLabel}
        isOptionEqualToValue={(a, b) => a.id === b.id}
        getOptionDisabled={(option) =>
          value.length >= MAX_SELECTED_NODES && !value.some((v) => v.id === option.id)
        }
        renderInput={(params) => (
          <TextField {...params} label={label} size="small" error={!!error} helperText={error} />
        )}
      />
    </Grid>
  </>
)

export default NodeSelectRow
